import type { IThemeModeEnum } from "@/theme/types";
import { useUIStore } from "@/stores/uiStore";

const applyThemeMode = (value: IThemeModeEnum) => {
  const html: HTMLElement = document.querySelector("#html")!;
  const body: HTMLElement = document.querySelector("#body")!;
  const root: HTMLElement = document.querySelector("#root")!;

  html.dataset.theme = value;
  body.dataset.theme = value;
  root.dataset.theme = value;
};

// sets theme on page load
applyThemeMode(useUIStore.getState().theme);
// listens for further changes
useUIStore.subscribe((state) => state.theme, applyThemeMode);
